import { render, staticRenderFns } from "./form-table-prop.vue?vue&type=template&id=fa991fc4&scoped=true&"
import script from "./form-table-prop.vue?vue&type=script&lang=js&"
export * from "./form-table-prop.vue?vue&type=script&lang=js&"
import style0 from "./form-table-prop.vue?vue&type=style&index=0&id=fa991fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa991fc4",
  null
  
)

component.options.__file = "form-table-prop.vue"
export default component.exports